import BrandHeader from './BrandHeader.jsx';

const LINKS = [
  { to: '/', label: 'Command Center', end: true },
  { hash: '#mission', label: 'Mission' },
  { hash: '#live', label: 'Live Hubs' },
  { hash: '#pipeline', label: 'Pipeline' },
  { hash: '#loadout', label: 'Loadout' },
  { hash: '#support', label: 'Support Us' },
  { hash: '#contact', label: 'Contact' },
];

/** Site-wide header used by the home, account, and utility pages. */
export default function SocHeader() {
  return <BrandHeader links={LINKS} />;
}